export default __webpack_public_path__ + "static/elephantTrunk-logo.8ee7f5e6.svg";